<template>
	<div class="page-sidebar-wrapper">
                <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
                <!-- DOC: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
            <div id="menuprincipal" class="page-sidebar navbar-collapse collapse">
                    <!-- BEGIN SIDEBAR MENU -->
                    <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
                    <!-- DOC: Apply "page-sidebar-menu-hover-submenu" class right after "page-sidebar-menu" to enable hoverable(hover vs accordion) sub menu mode -->
                    <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
                    <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
                    <!-- DOC: Set data-keep-expand="true" to keep the submenues expanded -->
                    <!-- DOC: Set data-auto-speed="200" to adjust the sub menu slide up/down speed -->
                    <cpmenu></cpmenu>
                    <!-- END SIDEBAR MENU -->
                </div>
        </div><!-- Fim Conteiner Geral-->
</template>
<script>
    import Cpmenu from './menu/navmenu.vue'

    export default{
        data(){
            return{
                dados:{}
            }
        },
        components:{
            Cpmenu
        },
        ready(){
            
        }
    }
</script>
<style scoped>   
</style>


// WEBPACK FOOTER //
// menu.vue?297c0677